export default __webpack_public_path__ + "static/media/map.c961c1ef.svg";